import styled, { css } from "styled-components";

interface IStyleProps {
  fromEditTemplate?: boolean;
}

export const Root = styled.div`
  width: 255px;
  margin: 50px 78px 0px 50px;
  ${(props: IStyleProps) => (props.fromEditTemplate && css`
    flex: 1;
    width: auto;
    margin: 40px 60px 0px 0px;
  `)};
`;

export const Title = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
`